"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliance() {
  const headlineWords = [{
    text: "Global",
    italic: false,
    accent: false
  }, {
    text: "sourcing",
    italic: false,
    accent: false
  }, {
    text: "for",
    italic: false,
    accent: false
  }, {
    text: "the",
    italic: false,
    accent: false
  }, {
    text: "future",
    italic: true,
    accent: false
  }, {
    text: "of",
    italic: false,
    accent: false
  }, {
    text: "clinical",
    italic: false,
    accent: false
  }, {
    text: "excellence",
    italic: true,
    accent: true
  }, {
    text: "and",
    italic: false,
    accent: false
  }, {
    text: "care.",
    italic: false,
    accent: false
  }];
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [headlineMounted, setHeadlineMounted] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => setHeadlineMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = Math.min(scrollY * 0.15, 40);
  return <section data-section-id="2778" id="compliancecertificationshero" className="bg-background text-foreground relative overflow-hidden min-h-[90vh] flex items-center">
      <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-x-6 gap-y-10 md:gap-y-20">
          <div ref={labelRef} className={`col-span-12 md:col-span-2 transition-all duration-1000 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            
          </div>

          <div className="col-span-12 md:col-span-9 md:col-start-2">
            <h1 className="font-default font-semibold text-foreground !text-[80px]" style={{
            fontSize: "clamp(3.5rem, 8vw, 8rem)",
            lineHeight: "1.1",
            letterSpacing: "-0.03em"
          }}><span data-index="0" className="inline-block overflow-hidden align-bottom mr-[0.18em]" data-ast-id="f:/src/pages/Compliance/sections/Compliance.tsx|sig:cfq4qb" data-ast-start="2828" data-ast-end="3393" data-array-file="/src/pages/Compliance/sections/Compliance.tsx" data-array-name="headlineWords" data-array-start-line="98" data-array-end-line="98" data-is-from-array="true" data-is-nested-array="false" data-array-property-names="text" data-attr-property-mappings="data-index:i,key:i" data-array-index="0"><span className="inline-block transition-transform ease-out !text-6xl" data-ast-id="f:/src/pages/Compliance/sections/Compliance.tsx|sig:a6afhy" data-ast-start="2942" data-ast-end="3369" data-array-file="/src/pages/Compliance/sections/Compliance.tsx" data-array-name="headlineWords" data-array-start-line="98" data-array-end-line="98" data-is-from-array="true" data-is-nested-array="false" data-array-property-names="text" data-array-index="0" style={{
                transform: 'translateY(0%)',
                transitionDuration: '700ms',
                transitionDelay: '0ms'
              }}>Building Trusted Healthcare Partnerships Through Professional Evaluation and Strategic Distribution.</span></span></h1>
          </div>

          <div ref={paragraphRef} className={`col-span-12 md:col-span-4 md:col-start-2 transition-all duration-1000 ease-out delay-300 ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-default italic text-lg leading-relaxed text-foreground mb-6">We carefully evaluate, introduce, and develop selected healthcare technologies and products that combine clinical value, market potential, and sustainable business opportunities.</p>
            
            <Link to="#">
              
            </Link>
          </div>

          <motion.div ref={imageRef} initial={{
          opacity: 0,
          y: 40
        }} animate={imageVisible ? {
          opacity: 1,
          y: -parallaxOffset
        } : {
          opacity: 0,
          y: 40
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="col-span-12 md:col-span-4 md:col-start-9">
            <div className="relative rounded-lg overflow-hidden shadow-lg aspect-[3/4] bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1727079/img/medical_innovation_global.webp" alt="Professional medical device evaluation in a modern clinical environment" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              <div className="absolute inset-0 pointer-events-none" style={{
              background: "radial-gradient(ellipse at center, transparent 50%, hsla(210, 50%, 10%, 0.2) 100%)"
            }} />
            </div>
            <p className="font-default text-xs uppercase tracking-widest text-primary mt-4">
              Global Sourcing / 2024 / MS Biotechnology
            </p>
          </motion.div>
        </div>
      </div>

      <div aria-hidden="true" className="absolute left-0 right-0 bottom-0 h-px bg-border" />
    </section>;
}